import React from "react";
import { Link } from "react-router-dom";

const linkList = [
  {
    itemName: "Services",
    link: "/services",
  },
  {
    itemName: "Term & Conditions",
    link: "/terms-of-use",
  },
  {
    itemName: "Privacy Policy",
    link: "/privacy-policy",
  },
];

const Product = [
  {
    itemName: "Case Studies",
    link: "/case-studies",
  },
  {
    itemName: "About",
    link: "/about-us",
  },
  {
    itemName: "Contact",
    link: "/contact-us",
  },
];

const Footer = () => {
  return (
    <div className="row">
      <div className="col-12 col-xl-6">
        {/* <!--Animated Block--> */}
        <div className="ptf-animated-block" data-aos="fade" data-aos-delay="0">
          <div
            className="ptf-footer-heading has-black-color"
            style={{ maxWidth: "37.5rem" }}
          >
            We help companies design and build digital products with <span className="has-accent-1">AI</span>, <span className="has-accent-1">mobile</span>, and <span className="has-accent-1">web</span> technologies.
          </div>

          <br />
          <a className="fz-40 has-black-color" href="mailto:sales@Covetech.net">
            sales@Covetech.net
          </a>
        </div>
      </div>
      <div className="col-12 col-md-6 col-xl-3">
        {/* <!--Animated Block--> */}
        <div
          className="ptf-animated-block"
          data-aos="fade"
          data-aos-delay="100"
        >
          <div className="ptf-widget ptf-widget-links has-black-color">
            <h4 className="ptf-widget-title">Links</h4>
            <ul>
              {linkList.map((val, i) => (
                <li key={i}>
                  <a href={val.link}>{val.itemName}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 col-xl-3">
        {/* <!--Animated Block--> */}
        <div
          className="ptf-animated-block"
          data-aos="fade"
          data-aos-delay="200"
        >
          <div className="ptf-widget ptf-widget-text">
            <h4 className="ptf-widget-title">Company</h4>
            <div className="ptf-widget ptf-widget-links has-black-color">
              <ul>
                {Product.map((val, i) => (
                  <li key={i}>
                    <a href={val.link}>{val.itemName}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
